(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb404-pdp-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb404-pdp-assistant')) {
    customElements.define('lb404-pdp-assistant', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('[data-lb404-pdp]');
        this.buy = this.root?.querySelector('[data-add-to-cart]');
        if (!this.root || !this.buy || this.bound) return;
        this.bound = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.onVariant = (event) => {
          const variant = event.detail?.variant;
          this.variant = variant;
          requestAnimationFrame(() => this.sync());
        };
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.visibility(); });
        };
        this.root.addEventListener('variantChange', this.onVariant, { signal });
        window.addEventListener('scroll', this.onScroll, { passive: true, signal });
        window.addEventListener('resize', this.onScroll, { passive: true, signal });
        this.querySelector('[data-lb404-return-to-buy]').addEventListener('click', () => {
          const target = this.root.querySelector('.lb404-pdp-options') || this.root.querySelector('[data-lb404-purchase]');
          const input = target?.querySelector('input:checked, select, button:not(:disabled)');
          target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
          input?.focus({ preventScroll: true });
        }, { signal });
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.buy, { attributes: true, attributeFilter: ['disabled'] });
        this.visibility();
      }
      sync() {
        const price = this.root.querySelector('[data-product-price]');
        if (price) this.querySelector('[data-lb404-sticky-price]').textContent = price.textContent.trim();
        if (this.variant !== undefined) {
          this.querySelector('[data-lb404-sticky-variant]').textContent = this.variant?.title === 'Default Title' ? '' : this.variant?.title || '';
          if (!this.variant) this.querySelector('[data-lb404-sticky-price]').textContent = '';
        }
        const label = this.buy.disabled ? this.dataset.unavailableLabel : this.dataset.availableLabel;
        this.querySelector('[data-lb404-return-to-buy]').firstChild.textContent = label;
        this.visibility();
      }
      visibility() {
        this.hidden = window.innerWidth >= 990 || this.buy.getBoundingClientRect().bottom >= 0;
        document.documentElement.style.setProperty('--lb404-pdp-sticky-space', this.hidden ? '0px' : `${this.offsetHeight}px`);
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); document.documentElement.style.removeProperty('--lb404-pdp-sticky-space'); this.bound = false; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
